export const CNIL_CONSENT_CHECKBOX =
  "*En cochant cette case, j'autorise l'utilisation de pixels et liens de suivi pour mesurer la délivrabilité et la performance des communications, et recevoir des contenus personnalisés. Pour plus d'informations, consultez notre politique de confidentialité.";

export const CNIL_CONSENT_EMAIL =
  "*En m'inscrivant, j'autorise l'utilisation de pixels et liens de suivi pour mesurer la délivrabilité et la performance des communications, et recevoir des contenus personnalisés. Pour plus d'informations, consultez notre politique de confidentialité.";

export const ERR_GENERIC = 'Une erreur est survenue.';
export const ERR_GENERIC_ORDER_DETAILS = `Cette information n'est pas disponible actuellement.`;
export const ERR_NOT_FOUND = 'Cet article n’est plus disponible.';
export const TXT_BACK = 'Retour';
